var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 47,
    viewBox: "0 0 104 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 47,
    rx: 23.5,
    fill: "#48AB4E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 23,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0305 23.3636C33.0305 24.9943 32.7322 26.3963 32.1357 27.5696C31.5391 28.7379 30.7212 29.6378 29.6822 30.2692C28.6481 30.8956 27.4723 31.2088 26.1548 31.2088C24.8324 31.2088 23.6516 30.8956 22.6126 30.2692C21.5785 29.6378 20.7631 28.7354 20.1665 27.5621C19.57 26.3888 19.2717 24.9893 19.2717 23.3636C19.2717 21.733 19.57 20.3335 20.1665 19.1651C20.7631 17.9918 21.5785 17.092 22.6126 16.4656C23.6516 15.8342 24.8324 15.5185 26.1548 15.5185C27.4723 15.5185 28.6481 15.8342 29.6822 16.4656C30.7212 17.092 31.5391 17.9918 32.1357 19.1651C32.7322 20.3335 33.0305 21.733 33.0305 23.3636ZM30.7486 23.3636C30.7486 22.1207 30.5472 21.0742 30.1445 20.2241C29.7468 19.369 29.1999 18.7227 28.5039 18.2852C27.8129 17.8427 27.0298 17.6214 26.1548 17.6214C25.2749 17.6214 24.4893 17.8427 23.7983 18.2852C23.1072 18.7227 22.5604 19.369 22.1577 20.2241C21.7599 21.0742 21.5611 22.1207 21.5611 23.3636C21.5611 24.6065 21.7599 25.6555 22.1577 26.5107C22.5604 27.3608 23.1072 28.0071 23.7983 28.4496C24.4893 28.8871 25.2749 29.1058 26.1548 29.1058C27.0298 29.1058 27.8129 28.8871 28.5039 28.4496C29.1999 28.0071 29.7468 27.3608 30.1445 26.5107C30.5472 25.6555 30.7486 24.6065 30.7486 23.3636ZM48.2306 15.7273V31H46.1127L38.3495 19.799H38.2078V31H35.9035V15.7273H38.0363L45.8069 26.9432H45.9486V15.7273H48.2306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleon);
export default __webpack_public_path__ + "static/media/toggleon.241dfdcaa73a94d89d453792a9cc9019.svg";
export { ForwardRef as ReactComponent };